import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import WishList from "./pages/WishList";
import Applied from "./pages/Applied";
import Account from "./pages/Account";
import BottomNav from "./components/BottomNav";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Upload from "./pages/Upload";
import ItemView from "./pages/ItemView";
import ApplyPage from "./pages/ApplyPage";
import AdminPanel from "./pages/AdminPanel";
import EditJob from "./pages/EditJob";
import MainLogo from "../src/assets/img/main_logo.png"

import "./App.css";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 3000); 
    return () => clearTimeout(timer);
  }, []);

  if (showSplash) {
    return (
      <div className="splash-screen">
        <img src={MainLogo} alt="Logo" className="splash-logo" />
        <div className="splash-loader"></div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/wishlist" element={<WishList />} />
          <Route path="/messages" element={<Applied />} />
          <Route path="/account" element={<Account />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/item/:id" element={<ItemView />} />
          <Route path="/apply/:id" element={<ApplyPage />} />
          <Route path="/edit/:id" element={<EditJob />} />
        </Routes>
        <BottomNav />
      </div>
    </Router>
  );
}

export default App;
